import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { Form, Input, Button, Checkbox, message } from 'antd';
import Uploader from '@elem/compCommon/Uploader';
import styles from './index.module.scss';
import { ServicesIcon, CancelIcon } from '@/components/UI/svg/Ecocredits';
import { loginUser } from '@/utils/cookie';
import { plusMemberCustomerService } from '@/service/vip';
import { useGlobal } from '@/utils/useGlobal';

/**
 * 日本专属客服弹窗
 * @returns
 */
const DedicatedCustomer: React.FC = () => {
    const [open, setOpen] = useState<any>(false);
    const [form] = Form.useForm();
    const { locale } = useRouter();
    const info = loginUser();
    const [agreed, setAgreed] = useState<boolean>(false);
    const [modalBottom, setModalBottom] = useState<number>(0);
    const [sendStatus, setSendStatus] = useState<boolean>(false);
    const { isMobile } = useGlobal();

    const handleOpen = () => {
        setOpen(true);
    };

    const handleCancel = () => {
        setOpen(false);
    };

    const handleChangeAgreed = (e: any) => {
        setAgreed(e.target.checked);
    };

    const onValuesChange = (changedValues: any, allValues: any) => {
        if (allValues.customerName && allValues.email && allValues.content) {
            setSendStatus(true);
        } else {
            setSendStatus(false);
        }
    };

    const getContentScorll = () => {
        const scrollContainer = document.getElementById('question-dedicated-content');
        if (scrollContainer) {
            scrollContainer.scrollTop = scrollContainer?.scrollHeight;
        }
    };

    const handleSubmit = () => {
        form.validateFields().then(async (valid: any) => {
            if (valid) {
                const res = await plusMemberCustomerService(locale as string, { ...valid, agreed });
                if (res.code === '0') {
                    setOpen(false);
                    message.success('お問い合わせ受付が完了いたしました。お問い合わせいただきました内容を確認後、担当者よりご連絡いたします。');
                    form.resetFields();
                    setAgreed(false);
                    setSendStatus(false);
                }
            }
        });
    };

    useEffect(() => {
        if (window && !isMobile) {
            const innerH = window.innerHeight;
            if (innerH && innerH < 805) {
                setModalBottom(-100);
            }
        }
    }, []);

    return (
        <div className={styles.DedicatedCustomer}>
            <div className="service-box">
                <div className="icon-outer" onClick={handleOpen}>
                    <ServicesIcon />
                </div>
                <div
                    className={`dedicated-modal`}
                    style={modalBottom ? { display: open ? 'block' : 'none', bottom: `${modalBottom}px` } : { display: open ? 'block' : 'none' }}
                >
                    <div className="dedicated-header">
                        <div className="dedicated-title">お問い合わせ</div>
                        <CancelIcon onClick={handleCancel} />
                    </div>
                    <div className="dedicated-content" id="question-dedicated-content">
                        <div className="dedicated-content-bg">
                            <Form
                                colon={false}
                                layout="vertical"
                                form={form}
                                onValuesChange={onValuesChange}
                                initialValues={{ email: info?.user?.email || '' }}
                            >
                                <Form.Item label="お名前" name="customerName" rules={[{ required: true, message: '* は入力必須項目です' }]}>
                                    <Input maxLength={50}></Input>
                                </Form.Item>
                                <Form.Item label="メールアドレス" name="email" rules={[{ required: true, message: '* は入力必須項目です' }]}>
                                    <Input disabled></Input>
                                </Form.Item>
                                <Form.Item label="注文番号" name="orderId">
                                    <Input maxLength={50}></Input>
                                </Form.Item>
                                <Form.Item label="お問い合わせ内容" name="content" rules={[{ required: true, message: '* は入力必須項目です' }]}>
                                    <Input.TextArea maxLength={500} showCount></Input.TextArea>
                                </Form.Item>
                                <Form.Item name="fileUrlList" className="file-btn">
                                    <Uploader
                                        maxCount={10}
                                        size={5 * 1024 * 1024}
                                        types={[
                                            'image/jpeg',
                                            'image/png',
                                            'image/gif',
                                            'image/webp',
                                            'application/pdf',
                                            'jpg',
                                            'jpeg',
                                            'png',
                                            'gif',
                                            'webp',
                                            'pdf',
                                        ]}
                                        accept="image/*,application/pdf"
                                        onChange={() => getContentScorll()}
                                    />
                                </Form.Item>
                            </Form>
                        </div>
                    </div>
                    <div className="dedicated-bottom">
                        <div className="dedicated-bottom-content">
                            <Checkbox onChange={handleChangeAgreed} checked={agreed}>
                                EcoFlow
                                <a className="link" href={'https://account.ecoflow.com/agreement/ja-jp/PrivacyPolicy.html'} target="_blank" rel="noreferrer">
                                    プライバシーポリシー
                                </a>{' '}
                                を読み、上記の情報が事前に収集されることに同意します。
                            </Checkbox>
                        </div>
                        <Button type="primary" block className="send-btn" onClick={handleSubmit} disabled={!(sendStatus && agreed)}>
                            送信
                        </Button>
                        <div className="dedicated-bottom-tip">*が付いているフィールドは必須です。</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DedicatedCustomer;
